(() => {
  const escapeHtml = (value = '') =>
    String(value).replace(/[&<>'"]/g, (character) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      "'": '&#39;',
      '"': '&quot;',
    })[character]);

  const getProducts = () => {
    if (window.zeoneraProductSearchIndex) return window.zeoneraProductSearchIndex;

    const index = document.querySelector('#zeonera-product-search-index');
    if (!index) return [];

    try {
      window.zeoneraProductSearchIndex = JSON.parse(index.textContent);
    } catch (error) {
      console.error('Unable to load the ZeonEra product search index.', error);
      window.zeoneraProductSearchIndex = [];
    }

    return window.zeoneraProductSearchIndex;
  };

  const findProducts = (query, limit = 6) => {
    const normalizedQuery = query.trim().toLocaleLowerCase();
    const terms = normalizedQuery.split(/\s+/).filter(Boolean);
    if (!terms.length) return [];

    return getProducts()
      .map((product) => {
        const title = product.title.toLocaleLowerCase();
        const searchableText = product.searchText.toLocaleLowerCase();
        if (!terms.every((term) => searchableText.includes(term))) return null;

        let score = 0;
        if (title === normalizedQuery) score += 100;
        if (title.startsWith(normalizedQuery)) score += 60;
        if (title.includes(normalizedQuery)) score += 30;
        score += terms.filter((term) => title.includes(term)).length * 5;
        return { product, score };
      })
      .filter(Boolean)
      .sort((first, second) => second.score - first.score || first.product.title.localeCompare(second.product.title))
      .slice(0, limit)
      .map(({ product }) => product);
  };

  const productImage = (product, className, alt = '') => {
    if (!product.image) return '';
    return `<img class="${className}" src="${escapeHtml(product.image)}" alt="${escapeHtml(alt)}" loading="lazy" width="720" height="720">`;
  };

  const predictiveProduct = (product, index) => `
    <li id="predictive-search-option-product-${index + 1}" class="predictive-search__list-item" role="option" aria-selected="false">
      <a href="${escapeHtml(product.url)}" class="predictive-search__item predictive-search__item--link-with-thumbnail link link--text" tabindex="-1">
        ${productImage(product, 'predictive-search__image')}
        <div class="predictive-search__item-content">
          <p class="predictive-search__item-heading h5">${escapeHtml(product.title)}</p>
          <span class="price-item price-item--regular">${escapeHtml(product.price)}</span>
        </div>
      </a>
    </li>`;

  const createPredictiveMarkup = (products) => `
    <div id="predictive-search-results" role="listbox">
      <div id="predictive-search-results-groups-wrapper" class="predictive-search__results-groups-wrapper predictive-search__results-groups-wrapper--no-suggestions">
        <div class="predictive-search__result-group">
          <div>
            <h2 id="predictive-search-products" class="predictive-search__heading text-body caption-with-letter-spacing">Products</h2>
            <ul id="predictive-search-results-products-list" class="predictive-search__results-list list-unstyled" role="group" aria-labelledby="predictive-search-products">${products.map(predictiveProduct).join('')}</ul>
          </div>
        </div>
      </div>
      <span class="hidden" data-predictive-search-live-region-count-value data-total-results="${products.length}">${products.length} products found</span>
    </div>`;

  const fallbackProductCard = (product) => `
    <article class="card" data-reveal>
      <div class="card-stage is-photo">
        ${productImage(product, 'prod-photo', product.title)}
      </div>
      <div class="card-body">
        <div class="card-row">
          <h3>${escapeHtml(product.title)}</h3>
          <span class="price">${escapeHtml(product.price)}</span>
        </div>
      </div>
      <a class="card-link" href="${escapeHtml(product.url)}" aria-label="View ${escapeHtml(product.title)}"></a>
    </article>`;

  const productCard = (product) => {
    const templates = document.querySelectorAll('template[data-zeonera-product-card]');

    for (const template of templates) {
      if (template.dataset.zeoneraProductCard === product.url) return template.innerHTML;
    }

    return fallbackProductCard(product);
  };

  const renderSearchFallback = () => {
    const fallback = document.querySelector('[data-zeonera-search-fallback]');
    if (!fallback) return;

    const products = findProducts(fallback.dataset.query || '', 24);
    if (!products.length) return;

    fallback.hidden = false;
    fallback.innerHTML = `<h2 class="title title--primary">Matching products</h2><div class="products products--airy">${products.map(productCard).join('')}</div>`;
    document.querySelector('[data-zeonera-search-no-results]')?.setAttribute('hidden', '');
  };

  window.ZeonEraProductSearch = { createPredictiveMarkup, findProducts };
  renderSearchFallback();
})();
